import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { titleForPath } from '@/lib/page-titles';

export function SiteHeader() {
  const location = useLocation();
  const title = titleForPath(location.pathname);

  // `titleForPath` existed and was tested, but its only consumer was the <h1> below — `document.title`
  // was written NOWHERE, so every tab read the static string from index.html. Staff keep Production,
  // Gang sheets and Press open at once and could not tell the tabs apart; the history dropdown and
  // every bookmark were identically named too.
  useEffect(() => {
    document.title = title === 'Dashboard' ? 'Fast Screen Print' : `${title} — Fast Screen Print`;
  }, [title]);

  return (
    // Sticky because this header carries the ONLY way to open the nav on a phone (the sidebar collapses
    // to a Sheet below 768px, opened solely by the trigger below). Nothing up the tree establishes a
    // scroll container — the wrapper is `flex min-h-svh` with no overflow — so the document body
    // scrolls and this used to scroll away with it. On a long page (the production board runs to
    // several thousand pixels) that left no way to leave the page, no way to refresh, and no reminder
    // of where you were, without scrolling all the way back up.
    //
    // z-30 sits above the desktop sidebar (z-10) and below the mobile Sheet + its overlay (z-50), which
    // is the order that matters: the menu must cover the header, not slide under it.
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4">
      {/* 28px is under the house phone floor (/count uses 44px, /scan 56px) — and this is the single
          most important target in the app on a phone, because it is the only route to the nav. */}
      <SidebarTrigger className="-ml-1 size-11 md:size-7" />
      <Separator orientation="vertical" className="h-4" />
      <h1 className="text-sm font-semibold leading-tight">{title}</h1>
    </header>
  );
}
